import { LocationSource } from '@carvana/merch-geolocation';
import { useContext, useMemo, useRef } from 'react';
import { axios } from '~/clients';
import { DELIVERY_CONTEXT } from '~/constants/endpoints';
import UserContext, { useUserLocation } from '~/context/common/UserContext';
import {
  DeliveryApi,
  DeliveryData,
  GeoApi,
  LocationChangeCallback,
  LocationData
} from '~/contracts/common/Geolocation';
import getGeolocationApi from '~/services/common/getGeoLocationApi';

const fetchDelivery = (zipcode: string): Promise<DeliveryData> =>
  axios
    .get<DeliveryData>(`${DELIVERY_CONTEXT}?zip5=${zipcode}`)
    .then(res => res.data);

type GeoConfig = {
  geoApi: GeoApi;
  fetchDelivery: DeliveryApi;
  onCloseHandler: () => void;
  onUserLocationChange?: LocationChangeCallback;
};

type OwnArgs = {
  onSuccessfulZipChange?: () => void;
  setGeolocationModalOpen: (open: boolean) => void;
};

export default function useGeoLocationConfig({
  onSuccessfulZipChange,
  setGeolocationModalOpen
}: OwnArgs): GeoConfig {
  const {
    location: { setData: setLocation }
  } = useContext(UserContext);
  const userLocation = useUserLocation();
  const geolocation = useRef<Partial<LocationData>>(userLocation);

  return useMemo<GeoConfig>(
    () => ({
      fetchDelivery,
      geoApi: getGeolocationApi(),
      onCloseHandler() {
        setGeolocationModalOpen(false);
        onSuccessfulZipChange?.();
      },
      onUserLocationChange({ location }) {
        if (geolocation.current.zip === location.zip) return;

        geolocation.current = location;
        setLocation({
          ...location,
          isFromCookies: false,
          source: LocationSource.Modal
        });
      }
    }),
    [onSuccessfulZipChange, setGeolocationModalOpen, setLocation]
  );
}
